import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { localDateStr } from '../utils/date'
import useIsMobile from '../hooks/useIsMobile'

export default function AS({ profile }) {
  const [asList, setAsList] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showDetail, setShowDetail] = useState(null)
  const [search, setSearch] = useState('')
  const [form, setForm] = useState({ plate:'', customer:'', contact:'', worker:'', repair:'' })
  const [updateContent, setUpdateContent] = useState('')
  const [loading, setLoading] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => { fetchAS() }, [])

  async function fetchAS() {
    const { data } = await supabase.from('as_records').select('*').order('created_at', { ascending: false })
    if (data) setAsList(data)
  }

  async function submitAS() {
    if (!form.plate || !form.customer) { alert('차량번호와 고객성함을 입력하세요'); return }
    setLoading(true)
    const today = localDateStr()
    await supabase.from('as_records').insert({
      date: today,
      plate: form.plate,
      customer: form.customer,
      contact: form.contact,
      worker: form.worker,
      history: [{ date: today, content: form.repair || '(내용 없음)' }]
    })
    setShowModal(false)
    setForm({ plate:'', customer:'', contact:'', worker:'', repair:'' })
    fetchAS()
    setLoading(false)
  }

  async function addUpdate() {
    if (!updateContent) { alert('내용을 입력하세요'); return }
    const today = localDateStr()
    const newHistory = [...(showDetail.history || []), { date: today, content: updateContent }]
    await supabase.from('as_records').update({ history: newHistory }).eq('id', showDetail.id)
    setUpdateContent('')
    fetchAS()
    // 상세 모달 데이터 갱신
    const { data } = await supabase.from('as_records').select('*').eq('id', showDetail.id).single()
    if (data) setShowDetail(data)
  }

  async function deleteAS(id) {
    if (!window.confirm('이 AS 기록을 삭제할까요?')) return
    await supabase.from('as_records').delete().eq('id', id)
    setShowDetail(null)
    fetchAS()
  }

  const filtered = asList.filter(a => {
    const q = search.toLowerCase()
    if (!q) return true
    return a.plate?.toLowerCase().includes(q) || a.customer?.includes(q)
  })

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20, flexWrap:'wrap', gap:10 }}>
        <div>
          <div style={{ fontSize:18, fontWeight:700, marginBottom:4 }}>AS 관리</div>
          <div style={{ fontSize:13, color:'#a09e99' }}>차량번호 · 고객 · 수리내역 기록</div>
        </div>
        <button onClick={() => setShowModal(true)}
          style={{ padding:'8px 16px', borderRadius:8, border:'none', background:'#2d5a3d', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:500 }}>
          + AS 접수
        </button>
      </div>

      {/* 검색 */}
      <div style={{ marginBottom:20 }}>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="차량번호, 고객성함 검색..."
          style={{ width:'100%', padding:'9px 14px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', outline:'none', boxSizing:'border-box' }} />
      </div>

      {/* 모바일: 카드 목록 */}
      {isMobile ? (
        filtered.length === 0 ? (
          <div style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, textAlign:'center', padding:40, color:'#a09e99', fontSize:13 }}>
            AS 이력이 없습니다
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {filtered.map(a => (
              <div key={a.id} onClick={() => setShowDetail(a)}
                style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, padding:14, cursor:'pointer', boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8, gap:8 }}>
                  <span style={{ border:'2px solid #1a1916', borderRadius:5, padding:'2px 10px', fontSize:13, fontWeight:700, letterSpacing:'0.04em', whiteSpace:'nowrap' }}>
                    {a.plate}
                  </span>
                  <span style={{ fontSize:11, color:'#a09e99', flexShrink:0 }}>{a.date}</span>
                </div>
                <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>
                  {a.customer}
                  {a.worker && <span style={{ fontSize:11, fontWeight:400, color:'#a09e99', marginLeft:8 }}>담당 {a.worker}</span>}
                </div>
                <div style={{ fontSize:12, color:'#6b6860', lineHeight:1.5, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                  {a.history?.[a.history.length - 1]?.content || a.history?.[0]?.content}
                </div>
                {a.history?.length > 1 && (
                  <div style={{ fontSize:11, color:'#4a8c60', marginTop:6 }}>처리 이력 {a.history.length}건</div>
                )}
              </div>
            ))}
          </div>
        )
      ) : (
      <div style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              {['접수일','차량번호','고객성함','연락처','수리내역','담당자',''].map(h => (
                <th key={h} style={{ padding:'10px 14px', fontSize:11, fontWeight:600, color:'#a09e99', borderBottom:'1px solid #e5e3de', background:'#f9f8f6', textAlign:'left', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign:'center', padding:40, color:'#a09e99' }}>AS 이력이 없습니다</td></tr>
            ) : filtered.map(a => (
              <tr key={a.id} style={{ borderBottom:'1px solid #e5e3de' }}>
                <td style={{ padding:'12px 14px' }}>{a.date}</td>
                <td style={{ padding:'12px 14px' }}>
                  <span style={{ background:'#fff', border:'2px solid #1a1916', borderRadius:5, padding:'2px 10px', fontSize:13, fontWeight:700, letterSpacing:'0.04em' }}>
                    {a.plate}
                  </span>
                </td>
                <td style={{ padding:'12px 14px', fontWeight:600 }}>{a.customer}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#6b6860' }}>{a.contact}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#6b6860', maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {a.history?.[0]?.content}
                </td>
                <td style={{ padding:'12px 14px' }}>{a.worker}</td>
                <td style={{ padding:'12px 14px' }}>
                  <button onClick={() => setShowDetail(a)}
                    style={{ padding:'4px 12px', border:'1px solid #e5e3de', borderRadius:6, background:'#fff', cursor:'pointer', fontSize:12 }}>
                    상세
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}

      {/* 접수 모달 */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div style={{ background:'#fff', borderRadius:14, width:480, maxWidth:'95vw', boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid #e5e3de', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:15, fontWeight:700 }}>AS 접수</span>
              <button onClick={() => setShowModal(false)} style={{ border:'none', background:'#f9f8f6', borderRadius:6, width:28, height:28, cursor:'pointer', fontSize:16 }}>✕</button>
            </div>
            <div style={{ padding:'20px 24px' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>차량번호</label>
                  <input value={form.plate} onChange={e => setForm({...form, plate:e.target.value})}
                    placeholder="예) 12가 3456"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', boxSizing:'border-box' }} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>고객성함</label>
                  <input value={form.customer} onChange={e => setForm({...form, customer:e.target.value})}
                    placeholder="홍길동"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', boxSizing:'border-box' }} />
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>연락처</label>
                  <input value={form.contact} onChange={e => setForm({...form, contact:e.target.value})}
                    placeholder="010-0000-0000"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', boxSizing:'border-box' }} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>담당자</label>
                  <input value={form.worker} onChange={e => setForm({...form, worker:e.target.value})}
                    placeholder="담당자 이름"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', boxSizing:'border-box' }} />
                </div>
              </div>
              <div>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>수리내역 / 증상</label>
                <textarea value={form.repair} onChange={e => setForm({...form, repair:e.target.value})}
                  placeholder="증상 및 수리 내용을 상세히 입력하세요" rows={4}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', resize:'vertical', boxSizing:'border-box' }} />
              </div>
            </div>
            <div style={{ padding:'16px 24px', borderTop:'1px solid #e5e3de', display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={() => setShowModal(false)}
                style={{ padding:'8px 16px', border:'1px solid #e5e3de', borderRadius:8, background:'#fff', cursor:'pointer', fontSize:13 }}>취소</button>
              <button onClick={submitAS} disabled={loading}
                style={{ padding:'8px 16px', border:'none', borderRadius:8, background:'#2d5a3d', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:500 }}>
                {loading ? '접수 중...' : '접수하기'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 상세 모달 */}
      {showDetail && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e => e.target === e.currentTarget && setShowDetail(null)}>
          <div style={{ background:'#fff', borderRadius:14, width:560, maxWidth:'95vw', maxHeight:'90vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid #e5e3de', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:15, fontWeight:700 }}>{showDetail.plate} · {showDetail.customer}</span>
              <button onClick={() => setShowDetail(null)} style={{ border:'none', background:'#f9f8f6', borderRadius:6, width:28, height:28, cursor:'pointer', fontSize:16 }}>✕</button>
            </div>
            <div style={{ padding:'20px 24px' }}>
              {/* 기본 정보 */}
              <div style={{ background:'#f9f8f6', borderRadius:8, padding:14, marginBottom:16, display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                {[['차량번호', showDetail.plate], ['접수일', showDetail.date],
                  ['고객성함', showDetail.customer], ['연락처', showDetail.contact],
                  ['담당자', showDetail.worker]].map(([k,v]) => (
                  <div key={k}>
                    <div style={{ fontSize:10, color:'#a09e99', marginBottom:3 }}>{k}</div>
                    <div style={{ fontSize:13, fontWeight: k==='고객성함'||k==='차량번호'?600:400 }}>{v}</div>
                  </div>
                ))}
              </div>

              {/* 처리 이력 타임라인 */}
              <div style={{ fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:10 }}>처리 이력</div>
              <div style={{ marginBottom:16 }}>
                {(showDetail.history || []).map((h, i) => (
                  <div key={i} style={{ display:'flex', gap:14, paddingBottom:16, position:'relative' }}>
                    {i < showDetail.history.length - 1 && (
                      <div style={{ position:'absolute', left:14, top:28, bottom:0, width:1, background:'#e5e3de' }} />
                    )}
                    <div style={{ width:28, height:28, borderRadius:'50%', background:'#e8f2eb', border:'2px solid #4a8c60', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, flexShrink:0 }}>
                      {i === 0 ? '📥' : '🔧'}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:600 }}>{h.date}</div>
                      <div style={{ fontSize:12, color:'#6b6860', marginTop:6, background:'#f9f8f6', borderRadius:6, padding:'8px 10px', border:'1px solid #e5e3de', lineHeight:1.6 }}>
                        {h.content}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* 업데이트 입력 */}
              <div style={{ borderTop:'1px solid #e5e3de', paddingTop:14 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }}>수리내역 추가</label>
                <textarea value={updateContent} onChange={e => setUpdateContent(e.target.value)}
                  placeholder="추가 수리 내용 또는 처리 메모" rows={3}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', resize:'vertical', boxSizing:'border-box' }} />
              </div>
            </div>
            <div style={{ padding:'16px 24px', borderTop:'1px solid #e5e3de', display:'flex', justifyContent:'space-between' }}>
              <button onClick={() => deleteAS(showDetail.id)}
                style={{ padding:'8px 16px', border:'none', borderRadius:8, background:'#fdeaea', color:'#b83030', cursor:'pointer', fontSize:13, fontWeight:500 }}>
                🗑️ 삭제
              </button>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => setShowDetail(null)}
                  style={{ padding:'8px 16px', border:'1px solid #e5e3de', borderRadius:8, background:'#fff', cursor:'pointer', fontSize:13 }}>닫기</button>
                <button onClick={addUpdate}
                  style={{ padding:'8px 16px', border:'none', borderRadius:8, background:'#2d5a3d', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:500 }}>
                  내용 추가
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}